import { render, staticRenderFns } from "./ViewJSON.vue?vue&type=template&id=4938a8da"
import script from "./ViewJSON.vue?vue&type=script&lang=ts"
export * from "./ViewJSON.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports